<div *ngIf='formReady && dataReady' [formGroup]='inputForm'>
  <div class='row'>
    <div class='col col-md-2'>Subject:</div>
    <div class='col col-md-10'>
      <mat-form-field>
        <input formControlName='subject' matInput name='subject' />
      </mat-form-field>
    </div>
  </div>

  <div class='row'>
    <div class='col col-md-2'>Message:</div>
    <div class='col col-md-10'>
      <editor #editor
              (onInit)='onEditorInit($event)'
              [formControlName]="'reply_content'"
              [init]='editorConfig'
              apiKey='vh5cdpzhd4pw3dnz81yzmnw85e9965aysf26blj8m95hl5s1'
              plugins='link lists'
              toolbar='undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist'></editor>
    </div>
  </div>
</div>
